'use client';

import React from 'react';

interface SlapOrientationModalProps {
  onClose: () => void;
  stickerName?: string;
}

export default function SlapOrientationModal({
  onClose,
  stickerName
}: SlapOrientationModalProps) {
  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 
        flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-xl shadow-2xl max-w-md w-full 
          p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Click the map to Slap
        </h2>
        
        <div className="space-y-4 text-gray-700">
          <p className="text-base">
            Move the map to where you want to slap and click to draft a slap of sticker {' '}
            {stickerName ? (
              <strong>{stickerName}</strong>
            ) : (
              'this sticker'
            )} in your browser.
          </p>
          
          <p className="text-base">
            Click the <strong>Commit Slap</strong> button to 
            review your slap. You can delete it or slap it on the Base blockchain.
          </p>
        </div>

        <button
          onClick={onClose}
          className="mt-6 w-full px-6 py-3 bg-blue-600 
            text-white font-semibold rounded-lg 
            hover:bg-blue-700 transition-colors"
        >
          Got It
        </button>
      </div>
    </div>
  );
}

